import { Autocomplete, TextField, createFilterOptions } from '@mui/material';
import { Country } from '../types';

const filterCountries = createFilterOptions<Country>({
  stringify: (country) => `${country.name} ${country.code} ${country.melt_pour_code ?? ''}`,
});

export function countryLabel(country: Country, meltPour = false): string {
  const base = country.code ? `${country.name} (${country.code})` : country.name;
  if (meltPour && country.melt_pour_code) {
    return `${base} · ${country.melt_pour_code}`;
  }
  return base;
}

interface CountrySelectProps {
  countries: Country[];
  value: Country | null;
  onChange: (country: Country | null) => void;
  label?: string;
  required?: boolean;
  disabled?: boolean;
  size?: 'small' | 'medium';
  helperText?: string;
  sx?: object;
  showMeltPourCode?: boolean;
}

export default function CountrySelect({
  countries,
  value,
  onChange,
  label = 'Schmelzland',
  required = false,
  disabled = false,
  size,
  helperText,
  sx,
  showMeltPourCode = false,
}: CountrySelectProps) {
  const options = [...countries].sort((a, b) => a.name.localeCompare(b.name, 'de'));
  const labelOf = (country: Country) => countryLabel(country, showMeltPourCode);

  return (
    <Autocomplete
      options={options}
      getOptionLabel={labelOf}
      filterOptions={filterCountries}
      value={value}
      onChange={(_, next) => onChange(next)}
      autoHighlight
      autoSelect
      openOnFocus
      disabled={disabled}
      size={size}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      noOptionsText="Kein Land gefunden"
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          required={required}
          size={size}
          helperText={helperText}
          sx={sx}
        />
      )}
    />
  );
}
